import { Pipe, PipeTransform } from '@angular/core';
import { LeadAudit } from 'src/app/core/models/lead/lead-audit.model';

@Pipe({
    name: 'filterAudits',
    standalone: false
})
export class FilterAuditsPipe implements PipeTransform {

  transform(audits: LeadAudit[], categories: string[]): LeadAudit[] {
    if (categories.length == 0) return audits
    return audits.filter(audit => categories.includes(audit.category))
  }

}
